import * as React from 'react';

import { BankingSwitch } from '../../../bankingSwitch/components/BankingSwitch';

const BankingSwitchScreen = () => {
    return <BankingSwitch layout="full-screen" />;
};

export default BankingSwitchScreen;
